import { IProduct as IContentfulProduct } from 'marketing-site/@types/generated/contentful'
import { IProps as IHeroVertical } from 'marketing-site/src/mvp-v2/library/components/HeroVertical'
import { transformHeroVertical } from 'marketing-site/src/mvp/transformers/components/ContentfulHeroVertical'
import { IProps as IShapeSection } from 'marketing-site/src/mvp/library/elements/ShapeSection'
import { transformShapeSection } from 'marketing-site/src/mvp/transformers/elements/ContentfulShapeSection'
import { IProps as IContentfulFeatureSpotlightMVP } from 'marketing-site/src/mvp/library/components/FeatureSpotlight'
import { transformFeatureSpotlight } from 'marketing-site/src/mvp/transformers/components/ContentfulFeatureSpotlight'
import { IProps as ILargeTestimonialMvp } from 'marketing-site/src/mvp/library/components/LargeTestimonial'
import { transformLargeTestimonial } from 'marketing-site/src/mvp/transformers/components/ContentfulLargeTestimonial'
import { IProps as IFeatureSpotlightVertical } from 'marketing-site/src/mvp-v2/library/components/FeatureSpotlightVertical'
import { transformFeatureSpotlightVertical } from 'marketing-site/src/mvp/transformers/components/ContentfulFeatureSpotlightVertical'
import { IProps as IIconGrid } from 'marketing-site/src/mvp-v2/library/components/IconGrid'
import { transformIconGrid } from 'marketing-site/src/mvp-v2/transformers/components/ContentfulIconGrid'
import { IProps as ICardsWithImageMVP } from 'marketing-site/src/mvp/library/components/CardsWithImage'
import { IProps as IPreFooterCTABlock } from 'marketing-site/src/mvp/library/components/PreFooterCTABlock'
import { transformPreFooterCTABlock } from 'marketing-site/src/mvp/transformers/components/ContentfulPreFooterCTABlock'
import { IProps as ILogoCarousel } from 'marketing-site/src/mvp-v2/library/components/LogoCarousel'
import { transformWiredCardsMvp } from 'marketing-site/src/mvp/transformers/components/ContentfulLogoCarousel'
import { transformCardsWithImage } from 'marketing-site/src/mvp/transformers/components/ContentfulCardsWithImage'

export interface IProduct {
  heroVertical?: IHeroVertical
  shapeSection?: IShapeSection
  logoCarousel?: ILogoCarousel
  featureSpotlightMvp?: IContentfulFeatureSpotlightMVP
  featureSpotlightVerticalMVP?: IFeatureSpotlightVertical
  iconGrid?: IIconGrid
  cardsWithImageMVP?: ICardsWithImageMVP
  iconGridII?: IIconGrid
  largeTestimonialMvp?: ILargeTestimonialMvp
  shapeSectionII?: IShapeSection
  preFooterCTABlock?: IPreFooterCTABlock
}

export function transformProduct({
  fields: {
    heroVertical,
    shapeSection,
    logoCarousel,
    featureSpotlightMvp,
    iconGrid,
    featureSpotlightVertical,
    cardsWithImageMVP,
    iconGridII,
    largeTestimonialMvp,
    shapeSectionII,
    preFooterCTABlock,
  },
}: IContentfulProduct): IProduct {
  return {
    heroVertical: heroVertical && transformHeroVertical(heroVertical),
    shapeSection: shapeSection && transformShapeSection(shapeSection),
    logoCarousel: logoCarousel && transformWiredCardsMvp(logoCarousel),
    featureSpotlightMvp: featureSpotlightMvp && transformFeatureSpotlight(featureSpotlightMvp),
    iconGrid: iconGrid && transformIconGrid(iconGrid),
    featureSpotlightVerticalMVP:
      featureSpotlightVertical && transformFeatureSpotlightVertical(featureSpotlightVertical),
    cardsWithImageMVP: cardsWithImageMVP && transformCardsWithImage(cardsWithImageMVP),
    iconGridII: iconGridII && transformIconGrid(iconGridII),
    largeTestimonialMvp: largeTestimonialMvp && transformLargeTestimonial(largeTestimonialMvp),
    shapeSectionII: shapeSectionII && transformShapeSection(shapeSectionII),
    preFooterCTABlock: preFooterCTABlock && transformPreFooterCTABlock(preFooterCTABlock),
  }
}
